<ax-number-box  [placeholder]="placeholder"></ax-number-box>